var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"component",attrs:{"to":{
    name: (_vm.category + "-slug"),
    params: {
      slug: _vm.path
    }
  }}},[_c(_vm.element,{tag:"component"},[_vm._v(_vm._s(_vm.name))]),(_vm.price !== 0)?_c('span',[_vm._v(_vm._s(_vm.conversionPrice))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }